// PRODUÇÃO
const URL_BASE = "https://admin.imob86.concept.inf.br/Imob86Admin/Vue";
// HOMOLOGAÇÃO
//const URL_BASE = "http://10.10.1.62:8080/Imob86/Vue";
// DESENVOLVIMENTO
//const URL_BASE = "http://10.10.1.22:8080/Imob86-Admin/Vue";

const ADMINISTRADORAS_LISTAR = URL_BASE + "/Administradoras/Listar";
const ADMINISTRADORAS_RECUPERAR = URL_BASE + "/Administradoras/Recuperar";
const ADMINISTRADORAS_GRAVAR = URL_BASE + "/Administradoras/Gravar";
const ADMINISTRADORAS_REMOVER = URL_BASE + "/Administradoras/Remover";
const ADMINISTRADORAS_ADICIONAR_CONDOMINIO = URL_BASE + "/Administradoras/AdicionarCondominio";
const ADMINISTRADORAS_REMOVER_CONDOMINIO = URL_BASE + "/Administradoras/RemoverCondominio";


const ALUGUEIS_VERIFICAR_APROVACAO = URL_BASE + "/Alugueis/VerificarAprovacao";
const ALUGUEIS_APROVAR = URL_BASE + "/Alugueis/Aprovar";
const ALUGUEIS_DESAPROVAR = URL_BASE + "/Alugueis/Desaprovar";
const ALUGUEIS_DESOCUPAR = URL_BASE + "/Alugueis/Desocupar";
const ALUGUEIS_CALCULAR_FINALIZACAO = URL_BASE + "/Alugueis/CalcularFinalizacao";
const ALUGUEIS_FINALIZAR_CONCLUIDO = URL_BASE + "/Alugueis/FinalizarConcluido";
const ALUGUEIS_FINALIZAR = URL_BASE + "/Alugueis/Finalizar";
const ALUGUEIS_FINALIZAR_COM_RESTRICOES = URL_BASE + "/Alugueis/FinalizarComRestricoes";
const ALUGUEIS_CANCELAR_FINALIZACAO = URL_BASE + "/Alugueis/CancelarFinalizacao";
const ALUGUEIS_ATUALIZAR_SITUACAO_JURIDICA = URL_BASE + "/Alugueis/AtualizarSituacaoJuridica";
const ALUGUEIS_CANCELAR_DESOCUPACAO = URL_BASE + "/Alugueis/CancelarDesocupacao";
const ALUGUEIS_GRAVAR = URL_BASE + "/Alugueis/Gravar";
const ALUGUEIS_REMOVER = URL_BASE + "/Alugueis/Remover";
const ALUGUEIS_LISTAR = URL_BASE + "/Alugueis/Listar";
const ALUGUEIS_RECUPERAR = URL_BASE + "/Alugueis/Recuperar";
const ALUGUEIS_REAJUSTAR = URL_BASE + "/Alugueis/Reajustar";
const ALUGUEIS_CANCELAR_REAJUSTE = URL_BASE + "/Alugueis/CancelarReajuste";
const ALUGUEIS_RENOVAR = URL_BASE + "/Alugueis/Renovar";
const ALUGUEIS_CANCELAR_RENOVACAO = URL_BASE + "/Alugueis/CancelarRenovacao";
const ALUGUEIS_ALTERAR_RENOVACAO = URL_BASE + "/Alugueis/AlterarRenovacao";
const ALUGUEIS_PRORROGAR = URL_BASE + "/Alugueis/Prorrogar";
const ALUGUEIS_CANCELAR_PRORROGACAO = URL_BASE + "/Alugueis/CancelarProrrogacao";
const ALUGUEIS_ALTERAR_TAXA_ADMINISTRACAO = URL_BASE + "/Alugueis/AlterarTaxaAdministracao";
const ALUGUEIS_ULTIMA_TAXA_ADM_COMPLEMENTAR = URL_BASE + "/Alugueis/RecuperarUltimaTaxaAdministracaoComplementar";
const ALUGUEIS_RECUPERAR_MES_SERIE_PARA_FINALIZACAO = URL_BASE + "/Alugueis/RecuperarMesSerieParaFinalizacao";
const ALUGUEIS_RECUPERAR_RECIBOS_DESCONTO_POR_ACORDO = URL_BASE + "/Alugueis/RecuperarRecibosDescontoPorAcordo";
const ALUGUEIS_GRAVAR_DESCONTOS = URL_BASE + "/Alugueis/GravarDescontos"
const ALUGUEIS_GRAVAR_DESCONTOS_SALDO_NEGATIVO = URL_BASE + "/Alugueis/GravarDescontosSaldoNegativo"
const ALUGUEIS_REMOVER_DESCONTO = URL_BASE + "/Alugueis/RemoverDesconto"
const ALUGUEIS_ALTERAR_DATA_VENCIMENTO = URL_BASE + "/Alugueis/AlterarVencimento";
const ALUGUEIS_CANCELAR_ALTERACAO_VENCIMENTO = URL_BASE + "/Alugueis/CancelarAlteracaoVencimento";
const ALUGUEIS_EXIBIR_RESUMO_CONTRATO = URL_BASE + "/Alugueis/ExibirResumoContrato";
const ALUGUEIS_ALTERAR_VALOR_CONTRATO = URL_BASE + "/Alugueis/AlterarValorContrato";
const ALUGUEIS_ALTERAR_CARENCIA_CONTRATO = URL_BASE + "/Alugueis/AlterarCarencia";
const ALUGUEIS_RECUPERAR_ENVOLVIDOS = URL_BASE + "/Alugueis/RecuperarEnvolvidos";
const ALUGUEIS_GRAVAR_LANCAMENTO_FUTURO = URL_BASE + "/Alugueis/GravarLancamentoFuturo";
const ALUGUEIS_REMOVER_LANCAMENTO_FUTURO = URL_BASE + "/Alugueis/RemoverLancamentoFuturo"

const ARQUIVOS_UPLOAD = URL_BASE + "/Arquivos/Gravar"
const ARQUIVOS_REMOVER = URL_BASE + "/Arquivos/Remover"

const ARQUIVO_RETORNO_LISTAR = URL_BASE + "/ArquivoRetorno/Listar"
const ARQUIVO_RETORNO_PROCESSAR = URL_BASE + "/ArquivoRetorno/ProcessarArquivo"

const ATENDIMENTOS_LISTAR = URL_BASE + "/Atendimentos/Listar";
const ATENDIMENTOS_RECUPERAR = URL_BASE + "/Atendimentos/Recuperar";
const ATENDIMENTOS_CONCLUIR_PRE_CADASTRO = URL_BASE + "/Atendimentos/ConcluirPreCadastro";
const ATENDIMENTOS_CONCLUIR_CRIACAO_PERFIL = URL_BASE + "/Atendimentos/ConcluirCriacaoPerfil";
const ATENDIMENTOS_GRAVAR_IMOVEIS = URL_BASE + "/Atendimentos/GravarImoveis";
const ATENDIMENTOS_GRAVAR_VISITA = URL_BASE + "/Atendimentos/GravarVisita";
const ATENDIMENTOS_GRAVAR_AVALIACAO_VISITA = URL_BASE + "/Atendimentos/GravarAvaliacaoVisita";
const ATENDIMENTOS_LISTAR_IMOVEIS_SEMELHANTES = URL_BASE + "/Atendimentos/ListarImoveisSemelhantes";

const BAIRROS_LISTAR = URL_BASE + "/Bairros/Listar";
const BAIRROS_RECUPERAR = URL_BASE + "/Bairros/Recuperar";
const BAIRROS_GRAVAR = URL_BASE + "/Bairros/Gravar";
const BAIRROS_REMOVER = URL_BASE + "/Bairros/Remover";
const BAIRROS_GRAVAR_VARIACAO = URL_BASE + "/Bairros/GravarVariacoes";

const BOLETOS_AVULSOS_GRAVAR = URL_BASE + "/BoletosAvulsos/Gravar";
const BOLETOS_AVULSOS_REMOVER = URL_BASE + "/BoletosAvulsos/Remover";
const BOLETOS_AVULSOS_RECUPERAR = URL_BASE + "/BoletosAvulsos/Recuperar";
const BOLETOS_AVULSOS_GERAR = URL_BASE + "/BoletosAvulsos/Gerar";
const BOLETOS_AVULSOS_GERAR_BOLETOS = URL_BASE + "/BoletosAvulsos/GerarBoletosEmAberto";
const BOLETOS_AVULSOS_ENVIAR_BOLETO_POR_EMAIL = URL_BASE + "/BoletosAvulsos/EnviarBoletoAvulso";
const BOLETOS_AVULSOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL = URL_BASE + "/BoletosAvulsos/EnviarBoletosEmAbertoPorEmail";
const BOLETOS_AVULSOS_LISTAR_BAIXAS = URL_BASE + "/BoletosAvulsos/ListarBaixas";
const BOLETOS_AVULSOS_PAGAR = URL_BASE + "/BoletosAvulsos/Pagar";
const BOLETOS_AVULSOS_CANCELAR_PAGAMENTO = URL_BASE + "/BoletosAvulsos/CancelarPagamento";
const BOLETOS_AVULSOS_RECUPERAR_ENVOLVIDOS = URL_BASE + "/BoletosAvulsos/RecuperarEnvolvidos";
const BOLETOS_AVULSOS_PRORROGAR = URL_BASE + "/BoletosAvulsos/ProrrogarBoletoAvulso";
const BOLETOS_AVULSOS_CALCULAR = URL_BASE + "/BoletosAvulsos/CalcularBoletoAvulso";
const BOLETOS_AVULSOS_CANCELAR_PRORROGACAO = URL_BASE + "/BoletosAvulsos/CancelarProrrogacaoBoletoAvulso";

const CAIXAS_RECUPERAR_CAIXA_ABERTO = URL_BASE + "/Caixas/RecuperarCaixaAberto";
const CAIXAS_RECUPERAR_CHEQUES_NO_CAIXA = URL_BASE + "/Caixas/RecuperarChequesNoCaixa";
const CAIXAS_ABRIR = URL_BASE + "/Caixas/Abrir";
const CAIXAS_FECHAR = URL_BASE + "/Caixas/Fechar";
const CAIXAS_GRAVAR_LANCAMENTO = URL_BASE + "/Caixas/GravarLancamento";
const CAIXAS_REMOVER_LANCAMENTO = URL_BASE + "/Caixas/RemoverLancamento";
const CAIXAS_RECUPERAR_HISTORICO = URL_BASE + "/Caixas/RecuperarHistorico";
const CAIXAS_RECUPERAR_CAIXA_ANTERIOR = URL_BASE + "/Caixas/RecuperarCaixaAnterior";
const CAIXAS_RECUPERAR_HISTORICO_CHEQUE = URL_BASE + "/Caixas/RecuperarHistoricoCheque";
const CAIXAS_RECUPERAR_SALDO = URL_BASE + "/Caixas/RecuperarSaldo";

const CARACTERISTICAS_CONDOMINIO_LISTAR = URL_BASE + "/CaracteristicasCondominio/Listar";
const CARACTERISTICAS_CONDOMINIO_GRAVAR = URL_BASE + "/CaracteristicasCondominio/Gravar";
const CARACTERISTICAS_CONDOMINIO_RECUPERAR = URL_BASE + "/CaracteristicasCondominio/Recuperar";
const CARACTERISTICAS_CONDOMINIO_REMOVER = URL_BASE + "/CaracteristicasCondominio/Remover";

const CARACTERISTICAS_IMOVEL_LISTAR = URL_BASE + "/CaracteristicasImovel/Listar";
const CARACTERISTICAS_IMOVEL_GRAVAR = URL_BASE + "/CaracteristicasImovel/Gravar";
const CARACTERISTICAS_IMOVEL_RECUPERAR = URL_BASE + "/CaracteristicasImovel/Recuperar";
const CARACTERISTICAS_IMOVEL_REMOVER = URL_BASE + "/CaracteristicasImovel/Remover";

const CIDADES_LISTAR = URL_BASE + "/Cidades/Listar";
const CIDADES_RECUPERAR = URL_BASE + '/Cidades/Recuperar';
const CIDADES_GRAVAR = URL_BASE + '/Cidades/Gravar'
const CIDADES_REMOVER = URL_BASE + '/Cidades/Remover'
const CIDADES_GRAVAR_VARIACAO = URL_BASE + '/Cidades/GravarVariacoes'

const CLIENTES_LISTAR = URL_BASE + "/Clientes/Listar";
const CLIENTES_RECUPERAR = URL_BASE + "/Clientes/Recuperar";
const CLIENTES_GRAVAR = URL_BASE + "/Clientes/Gravar";
const CLIENTES_REATIVAR = URL_BASE + "/Clientes/Reativar";
const CLIENTES_REMOVER = URL_BASE + "/Clientes/Remover";
//const CLIENTES_VERIFICAR_TELEFONE = URL_BASE + "/Clientes/VerificarTelefone";
const CLIENTES_GRAVAR_CONTATO_REALIZADO = URL_BASE + "/Clientes/GravarContatoRealizado";
const CLIENTES_ATUALIZAR_CONTATO_REALIZADO = URL_BASE + "/Clientes/AtualizarContatoRealizado";
const CLIENTES_REMOVER_CONTATO_REALIZADO = URL_BASE + "/Clientes/RemoverContatoRealizado";
//const CLIENTES_CONCLUIR_CONTATO = URL_BASE + "/Clientes/ConcluirContato";
//const CLIENTES_REATIVAR = URL_BASE + "/Clientes/Reativar";
const CLIENTES_GRAVAR_CONTA_BANCARIA = URL_BASE + "/Clientes/GravarContaBancaria";
const CLIENTES_REMOVER_CONTA_BANCARIA = URL_BASE + "/Clientes/RemoverContaBancaria";
const CLIENTES_REMOVER_CONTA_BANCARIA_COM_REPASSE = URL_BASE + "/Clientes/RemoverContaBancariaComRepasse";
const CLIENTES_RECUPERAR_VISITA = URL_BASE + "/Clientes/RecuperarVisita";
const CLIENTES_GRAVAR_VISITA = URL_BASE + "/Clientes/GravarVisita";
const CLIENTES_REMOVER_VISITA = URL_BASE + "/Clientes/RemoverVisita";
const CLIENTES_GRAVAR_REGISTRO_COBRANCA = URL_BASE + "/Clientes/GravarCobranca"
const CLIENTES_LISTAR_COBRANCAS = URL_BASE + "/Clientes/ListarCobrancas";
const COBRANCAS_REMOVER = URL_BASE + "/Clientes/RemoverCobranca";

const CONDOMINIOS_LISTAR = URL_BASE + "/Condominios/Listar";
const CONDOMINIOS_GRAVAR = URL_BASE + "/Condominios/Gravar";
const CONDOMINIOS_RECUPERAR = URL_BASE + "/Condominios/Recuperar";
const CONDOMINIOS_REMOVER = URL_BASE + "/Condominios/Remover";

//CONTAS RECEBER/PAGAR
const CONTAS_LISTAR = URL_BASE + "/Contas/Listar";
const CONTAS_GRAVAR = URL_BASE + "/Contas/Gravar";
const CONTAS_APROVAR = URL_BASE + "/Contas/Aprovar";
const CONTAS_DESAPROVAR = URL_BASE + "/Contas/Desaprovar";
const CONTAS_DUPLICAR = URL_BASE + "/Contas/Duplicar";
const CONTAS_CRIAR_CONTA_MENSALIDADES = URL_BASE + "/Contas/CriarContaMensalidades";
const CONTAS_RECUPERAR = URL_BASE + "/Contas/Recuperar";
const CONTAS_CANCELAR = URL_BASE + "/Contas/Cancelar";
const CONTAS_REMOVER = URL_BASE + "/Contas/Remover";

const CONTAS_BANCARIAS_LISTAR = URL_BASE + "/ContasBancarias/Listar";
const CONTAS_BANCARIAS_RECUPERAR = URL_BASE + "/ContasBancarias/Recuperar";
const CONTAS_BANCARIAS_GRAVAR = URL_BASE + "/ContasBancarias/Gravar";
const CONTAS_BANCARIAS_REMOVER = URL_BASE + "/ContasBancarias/Remover";

const DASHBOARD_LISTAR_IMOVEIS_MAPA = URL_BASE + "/Dashboard/ListarImoveisMapa";
const DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_VENDIDOS_GRAFICO = URL_BASE + "/Dashboard/ListarImoveisCaptadosVendidos";
const DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_ALUGADOS_GRAFICO = URL_BASE + "/Dashboard/ListarImoveisCaptadosAlugados";
const DASHBOARD_LISTAR_ATENDIMENTOS_GRAFICO = URL_BASE + "/Dashboard/ListarAtendimentos";
const DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL = URL_BASE + "/Dashboard/RecuperarSumarioTipoImovel";
const DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioTipoImovelImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_STATUS = URL_BASE + "/Dashboard/RecuperarSumarioStatus";
const DASHBOARD_RECUPERAR_SUMARIO_STATUS_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioStatusImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_FOTOS = URL_BASE + "/Dashboard/RecuperarSumarioFotos";
const DASHBOARD_RECUPERAR_SUMARIO_FOTOS_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioFotosImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO = URL_BASE + "/Dashboard/RecuperarSumarioLocalizacao";
const DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioLocalizacaoImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_ATENDIMENTO = URL_BASE + "/Dashboard/RecuperarSumarioAtendimento";
const DASHBOARD_IMOVEIS_CAPTADOS = URL_BASE + "/Dashboard/ImoveisCaptados";
const DASHBOARD_IMOVEIS_VENDIDOS = URL_BASE + "/Dashboard/ImoveisVendidos";
const DASHBOARD_RECUPERAR_ALUGUEIS_ATRASADOS = URL_BASE + "/Dashboard/AlugueisAtrasados";
const DASHBOARD_RECUPERAR_CONTRATOS_VENCIDOS = URL_BASE + "/Dashboard/ContratosVencidos";
const DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_VENDA = URL_BASE + "/Dashboard/UltimosImoveisVenda";
const DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/UltimosImoveisAluguel";
const DASHBOARD_RECUPERAR_REPASSES_DO_DIA = URL_BASE + "/Dashboard/RepassesDoDia";
const DASHBOARD_RECUPERAR_REPASSES_ATRASADOS = URL_BASE + "/Dashboard/RepassesAtrasados";

const DESTAQUES_SITE_RECUPERAR_DESTAQUES_PRINCIPAIS = URL_BASE + "/DestaquesSite/RecuperarDestaquesPrincipais";
const DESTAQUES_SITE_GRAVAR_DESTAQUE_PRINCIPAL = URL_BASE + "/DestaquesSite/GravarDestaquePrincipal";
const DESTAQUES_SITE_REMOVER_DESTAQUE_PRINCIPAL = URL_BASE + "/DestaquesSite/RemoverDestaquePrincipal";

const EXTRATOS_DIMOB_LISTAR_PROPRIETARIOS = URL_BASE + "/ExtratosDimob/RecuperarProprietarios";
const EXTRATOS_DIMOB_GERAR_EXTRATOS = URL_BASE + "/ExtratosDimob/GerarExtratos";
const EXTRATOS_DIMOB_GERAR_ETIQUETAS = URL_BASE + "/ExtratosDimob/GerarEtiquetas";
const EXTRATOS_DIMOB_GERAR_ARQUIVO_IMPORTACAO = URL_BASE + "/ExtratosDimob/GerarArquivoImportacao";

const ENCERRAR_SESSAO = URL_BASE + "/Usuarios/EncerrarSessao";

const FORMULARIOS_LISTAR = URL_BASE + "/Formularios/Listar";
const FORMULARIOS_RECUPERAR_FORMULARIO = URL_BASE + "/Formularios/Recuperar";
const FORMULARIOS_REMOVER = URL_BASE + "/Formularios/Remover";
const FORMULARIOS_GRAVAR = URL_BASE + "/Formularios/Upload";
const FORMULARIOS_DOWNLOAD = URL_BASE + "/Formularios/Download";
const FORMULARIOS_GERAR = URL_BASE + "/Formularios/Gerar";
const FORMULARIOS_GERAR_RECIBO_COMISSAO = URL_BASE + "/Formularios/GerarReciboComissao";
const FORMULARIOS_GERAR_RECIBO_COMISSAO_UNICO = URL_BASE + "/Formularios/GerarReciboComissaoUnico";
const FORMULARIOS_RECUPERAR = URL_BASE + "/Formularios/ListarDiretoriosFormulario";
const FORMULARIOS_RECUPERAR_PERGUNTAS = URL_BASE + "/Formularios/RecuperarPerguntas";
const FORMULARIOS_CRIAR_DIRETORIO = URL_BASE + "/Formularios/CriarDiretorio";
const FORMULARIOS_REMOVER_DIRETORIO = URL_BASE + "/Formularios/RemoverDiretorio";
const FORMULARIOS_LISTAR_DIRETORIOS = URL_BASE + "/Formularios/ListarDiretorios";
const FORMULARIOS_SELECIONAR_DIRETORIO = URL_BASE + "/Formularios/SelecionarDiretorio";

//FORNECEDORES
const FORNECEDORES_LISTAR = URL_BASE + "/Fornecedores/Listar";
const FORNECEDORES_GRAVAR = URL_BASE + "/Fornecedores/Gravar";
const FORNECEDORES_RECUPERAR = URL_BASE + "/Fornecedores/Recuperar";
const FORNECEDORES_REMOVER = URL_BASE + "/Fornecedores/Remover";

//GRUPO_PLANO_CONTA
const GRUPO_PLANO_CONTA_LISTAR = URL_BASE + "/GrupoPlanoConta/Listar";
const GRUPO_PLANO_CONTA_GRAVAR = URL_BASE + "/GrupoPlanoConta/Gravar";
const GRUPO_PLANO_CONTA_RECUPERAR = URL_BASE + "/GrupoPlanoConta/Recuperar";
const GRUPO_PLANO_CONTA_REMOVER = URL_BASE + "/GrupoPlanoConta/Remover";

//TIPO_DESPESA
const TIPO_CONTA_GRAVAR = URL_BASE + "/TipoConta/Gravar";
const TIPO_CONTA_LISTAR = URL_BASE + "/TipoConta/Listar";
const TIPO_CONTA_RECUPERAR = URL_BASE + "/TipoConta/Recuperar";
const TIPO_CONTA_REMOVER = URL_BASE + "/TipoConta/Remover";

//SUB_GRUPO_CONTA
const SUB_GRUPO_LISTAR = URL_BASE + "/SubGrupoPlanoConta/Listar" 
const SUB_GRUPO_GRAVAR = URL_BASE + "/SubGrupoPlanoConta/Gravar"
const SUB_GRUPO_RECUPERAR = URL_BASE + "/SubGrupoPlanoConta/Recuperar"
const SUB_GRUPO_REMOVER = URL_BASE + "/SubGrupoPlanoConta/Remover"

const IMAGENS_UPLOAD = URL_BASE + "/Imagens/Gravar";
const IMAGENS_REORDENAR = URL_BASE + "/Imagens/Reordenar";
const IMAGENS_EXIBIR_NA_FICHA = URL_BASE + "/Imagens/ExibirNaFicha";
const IMAGENS_REMOVER = URL_BASE + "/Imagens/Remover";

const IMAGENS_CARROSSEL_UPLOAD = URL_BASE + "/ImagensCarrossel/Gravar";
const IMAGENS_CARROSSEL_LISTAR = URL_BASE + "/ImagensCarrossel/Listar";
const IMAGENS_CARROSSEL_REMOVER = URL_BASE + "/ImagensCarrossel/Remover";

const IMOBILIARIAS_LISTAR = URL_BASE + "/Imobiliarias/Listar";
const IMOBILIARIAS_RECUPERAR = URL_BASE + "/Imobiliarias/Recuperar";
const IMOBILIARIAS_GRAVAR = URL_BASE + "/Imobiliarias/Gravar";
const IMOBILIARIAS_REMOVER = URL_BASE + "/Imobiliarias/Remover";
const IMOBILIARIAS_RECUPERAR_PARAMETROS = URL_BASE + "/Imobiliarias/RecuperarParametros";
const IMOBILIARIAS_GRAVAR_PARAMETROS = URL_BASE + "/Imobiliarias/GravarParametros";
const IMOBILIARIAS_ALTERAR_LOGOMARCA = URL_BASE + "/Imobiliarias/AlterarLogomarca";
const IMOBILIARIAS_RECUPERAR_PARAMETROS_SITE = URL_BASE + "/ParametrosSite/Recuperar";
const IMOBILIARIAS_GRAVAR_PARAMETROS_SITE = URL_BASE + "/ParametrosSite/Gravar";
const IMOBILIARIAS_DESPUBLICAR_SITE = URL_BASE + "/ParametrosSite/DespublicarSite"
const IMOBILIARIAS_PUBLICAR_SITE = URL_BASE + "/ParametrosSite/Publicar";
const IMOBILIARIAS_ALTERAR_IMAGEM_SITE = URL_BASE + "/Imobiliarias/AlterarImagemSite";
const IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_ANIVERSARIO = URL_BASE + "/ParametrosEmailAniversario/Recuperar";
const IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_ANIVERSARIO = URL_BASE + "/ParametrosEmailAniversario/Gravar";
const IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_PROPRIETARIO = URL_BASE + "/ParametrosEmailAniversario/GravarImagemProprietario";
const IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_LOCATARIO = URL_BASE + "/ParametrosEmailAniversario/GravarImagemLocatario";
const IMOBILIARIAS_GRAVAR_IMOBILIARIAS_PARCEIRAS = URL_BASE + "/Imobiliarias/GravarParcerias"

const IMOBILIARIAS_PRE_CADASTRADAS_LISTAR = URL_BASE + "/ImobiliariasPreCadastradas/Listar";
const IMOBILIARIAS_PRE_CADASTRADAS_RECUPERAR = URL_BASE + "/ImobiliariasPreCadastradas/Recuperar";
const IMOBILIARIAS_PRE_CADASTRADAS_GRAVAR = URL_BASE + "/ImobiliariasPreCadastradas/Gravar";
const IMOBILIARIAS_PRE_CADASTRADAS_REMOVER = URL_BASE + "/ImobiliariasPreCadastradas/Remover";
const IMOBILIARIAS_PRE_CADASTRADAS_GERAR_PROPOSTA = URL_BASE + "/ImobiliariasPreCadastradas/GerarProposta";
const IMOBILIARIAS_PRE_CADASTRADAS_GERAR_CONTRATO = URL_BASE + "/ImobiliariasPreCadastradas/GerarContrato";

const IMOVEIS_LISTAR = URL_BASE + "/Imoveis/Listar";
const IMOVEIS_RECUPERAR = URL_BASE + "/Imoveis/Recuperar";
const IMOVEIS_RECUPERAR_ALUGUEL_ATIVO = URL_BASE + "/Imoveis/RecuperarAluguelAtivo";
const IMOVEIS_GRAVAR = URL_BASE + "/Imoveis/Gravar";
const IMOVEIS_DISPONIBILIZAR_VENDA = URL_BASE + "/Imoveis/DisponibilizarParaVenda";
const IMOVEIS_DISPONIBILIZAR_ALUGUEL = URL_BASE + "/Imoveis/DisponibilizarParaAluguel";
const IMOVEIS_DISPONIBILIZAR = URL_BASE + "/Imoveis/Disponibilizar";
const IMOVEIS_INDISPONIBILIZAR = URL_BASE + "/Imoveis/Indisponibilizar";
const IMOVEIS_ARQUIVAR = URL_BASE + "/Imoveis/Arquivar";
const IMOVEIS_DESARQUIVAR = URL_BASE + "/Imoveis/Desarquivar";
const IMOVEIS_REMOVER = URL_BASE + "/Imoveis/Remover";
const IMOVEIS_GRAVAR_LOCALIZACAO = URL_BASE + "/Imoveis/GravarLocalizacao";
const IMOVEIS_RECUPERAR_ULTIMO_ID = URL_BASE + "/Imoveis/RecuperarUltimoIdCadastrado";
const IMOVEIS_RECUPERAR_VISITA = URL_BASE + "/Imoveis/RecuperarVisita"; 
const IMOVEIS_GRAVAR_VISITA = URL_BASE + "/Imoveis/GravarVisita";
const IMOVEIS_REMOVER_VISITA = URL_BASE + "/Imoveis/RemoverVisita";
const IMOVEIS_RESERVAR_IMOVEL = URL_BASE + "/Imoveis/ReservarImovel";
const IMOVEIS_PRORROGAR_RESERVA_IMOVEL = URL_BASE + "/Imoveis/ProrrogarReservaImovel";
const IMOVEIS_DESFAZER_RESERVA = URL_BASE + "/Imoveis/DesfazerReserva";
const IMOVEIS_ENTREGAR_CHAVE = URL_BASE + "/Imoveis/EntregarChave";
const IMOVEIS_RECEBER_CHAVE = URL_BASE + "/Imoveis/ReceberChave";
const IMOVEIS_GRAVAR_LANCAMENTO_FUTURO = URL_BASE + "/Imoveis/GravarLancamentoFuturo";
const IMOVEIS_REMOVER_LANCAMENTO_FUTURO = URL_BASE + "/Imoveis/RemoverLancamentoFuturo";
const IMOVEIS_CALCULAR_PRECO_METRO_QUADRADO = URL_BASE + "/Imoveis/CalcularPrecoMetroQuadrado";

//LANCAMENTOS
const LANCAMENTOS_RECUPERAR = URL_BASE + "/Lancamentos/Recuperar";
const LANCAMENTOS_GRAVAR = URL_BASE + "/Lancamentos/Gravar";
const LANCAMENTOS_PAGAR = URL_BASE + "/Lancamentos/Pagar";
const LANCAMENTOS_CANCELAR = URL_BASE + "/Lancamentos/CancelarPagamento";
const LANCAMENTOS_REMOVER = URL_BASE + "/Lancamentos/Remover";
const LANCAMENTOS_DEVOLVER_CHEQUE = URL_BASE + "/Lancamentos/DevolverCheque";

const LOGGER_LISTAR = URL_BASE + "/Logger/Listar";

const OBSERVACOES_RECUPERAR = URL_BASE + "/Observacoes/Recuperar";
const OBSERVACOES_GRAVAR = URL_BASE + "/Observacoes/Gravar";
const OBSERVACOES_REMOVER = URL_BASE + "/Observacoes/Remover";

const PARCERIAS_LISTAR_DISPONIVEIS_PARCERIA = URL_BASE + "/Parcerias/ListarDisponiveisParceria";
const PARCERIAS_GRAVAR = URL_BASE + "/Parcerias/Gravar";

const PARCERIAS_LISTAR = URL_BASE + "/Parcerias/Listar";
const PARCERIAS_RECUPERAR = URL_BASE + "/Parcerias/Recuperar";
const PARCERIAS_SOLICITAR_PARCERIA = URL_BASE + "/Parcerias/SolicitarParceria";
const PARCERIAS_ACEITAR_PARCERIA = URL_BASE + "/Parcerias/AceitarParceria";
const PARCERIAS_REJEITAR_PARCERIA = URL_BASE + "/Parcerias/RejeitarParceria";
const PARCERIAS_RECUPERAR_IMOBILIARIAS_PARCEIRAS = URL_BASE + "/Parcerias/RecuperarImobiliariasParceiras";
const PARCERIAS_RECUPERAR_IMOVEL = URL_BASE + "/Parcerias/RecuperarImovelParceiro";
const PARCERIAS_LISTAR_IMOVEIS_PARCEIROS = URL_BASE + "/Parcerias/ListarImoveisParceiros";
const PARCERIAS_GRAVAR_IMOVEIS = URL_BASE + "/Parcerias/Gravar";

const PERFIS_USUARIO_LISTAR = URL_BASE + "/PerfisUsuario/Listar";
const PERFIS_USUARIO_RECUPERAR = URL_BASE + "/PerfisUsuario/Recuperar";
const PERFIS_USUARIO_GRAVAR = URL_BASE + "/PerfisUsuario/Gravar";
const PERFIS_USUARIO_REMOVER = URL_BASE + "/PerfisUsuario/Remover";

const PLACAS_LISTAR = URL_BASE + "/Placas/Listar";
const PLACAS_GRAVAR_PLACA_NO_IMOVEL = URL_BASE + "/Placas/GravarPlacaNoImovel";
const PLACAS_REMOVER_PLACA_DO_IMOVEL = URL_BASE + "/Placas/RemoverPlacaDoImovel";
const PLACAS_RECUPERAR = URL_BASE + "/Placas/Recuperar";
const PLACAS_GRAVAR = URL_BASE + "/Placas/Gravar";
const PLACAS_REMOVER = URL_BASE + "/Placas/Remover";

//PLANO_CONTA
const PLANO_CONTA_LISTAR = URL_BASE + "/ContaPlanoConta/Listar";
const PLANO_CONTA_GRAVAR = URL_BASE + "/ContaPlanoConta/Gravar";
const PLANO_CONTA_RECUPERAR = URL_BASE + "/ContaPlanoConta/Recuperar";
const PLANO_CONTA_REMOVER = URL_BASE + "/ContaPlanoConta/Remover";

const PORTAIS_RECUPERAR = URL_BASE + "/Portais/RecuperarPortal";
const PORTAIS_GRAVAR = URL_BASE + "/Portais/Gravar";

const RECIBOS_LISTAR_RECIBOS_CONTRATO = URL_BASE + "/Recibos/ListarRecibosDoContrato";
const RECIBOS_GERAR_BOLETOS_EM_ABERTO = URL_BASE + "/Recibos/GerarBoletosEmAberto";
const RECIBOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL = URL_BASE + "/Recibos/EnviarBoletosEmAbertoPorEmail";
const RECIBOS_GERAR_DEMONSTRATIVO = URL_BASE + "/Recibos/GerarDemonstrativo";
const RECIBOS_ENVIAR_DEMONSTRATIVO_POR_EMAIL = URL_BASE + "/Recibos/EnviarDemonstrativoPorEmail";
const RECIBOS_GERAR_BOLETO = URL_BASE + "/Recibos/GerarBoleto";
const RECIBOS_ENVIAR_BOLETO_POR_EMAIL = URL_BASE + "/Recibos/EnviarBoleto";
const RECIBOS_CALCULAR_ALUGUEL = URL_BASE + "/Recibos/CalcularAluguel";
const RECIBOS_CALCULAR_REPASSE = URL_BASE + "/Recibos/CalcularRepasse";
const RECIBOS_BLOQUEAR_BAIXA = URL_BASE + "/Recibos/BloquearBaixa";
const RECIBOS_DESBLOQUEAR_BAIXA = URL_BASE + "/Recibos/DesbloquearBaixa";
const RECIBOS_PRORROGAR_BOLETO = URL_BASE + "/Recibos/ProrrogarRecibo";
const RECIBOS_CANCELAR_PRORROGACAO = URL_BASE + "/Recibos/CancelarProrrogacao";
const RECIBOS_EFETUAR_PAGAMENTO = URL_BASE + "/Recibos/EfetuarPagamento";
const RECIBOS_CANCELAR_PAGAMENTO = URL_BASE + "/Recibos/CancelarPagamento";
const RECIBOS_LIBERAR_REPASSE = URL_BASE + "/Recibos/LiberarRepasse";
const RECIBOS_CANCELAR_REPASSE = URL_BASE + "/Recibos/CancelarRepasse";
const RECIBOS_GRAVAR_ITEM = URL_BASE + "/Recibos/GravarItemRecibo";
const RECIBOS_REMOVER_ITEM = URL_BASE + "/Recibos/RemoverItemRecibo";
const RECIBOS_LISTAR_BAIXAS = URL_BASE + "/Recibos/ListarBaixas";
const RECIBOS_LISTAR_REPASSES = URL_BASE + "/Recibos/ListarRepasses";
const RECIBOS_LIBERAR_REPASSE_EM_LOTE = URL_BASE + "/Recibos/LiberarRepasseEmLote";
const RECIBOS_GERAR_DEMONSTRATIVOS = URL_BASE + "/Recibos/GerarDemonstrativos";

const RELATORIOS_GERAR = URL_BASE + "/Relatorios/Gerar";
const RELATORIOS_GERAR_DIMOB = URL_BASE + "/Relatorios/GerarDimob";
const RELATORIOS_GERAR_RELATORIO_CLIENTES_ALUGUEL = URL_BASE + "/Relatorios/GerarRelatorioClientesAluguel";
const RELATORIOS_GERAR_RELATORIO_CLIENTES_VENDA = URL_BASE + "/Relatorios/GerarRelatorioClientesVenda";
const RELATORIOS_GERAR_RELATORIO_CONTRATOS_ALUGUEL = URL_BASE + "/Relatorios/GerarRelatorioContratosAluguel";
const RELATORIOS_GERAR_RELATORIO_IMOVEIS_ALUGUEL = URL_BASE + "/Relatorios/GerarRelatorioImoveisAluguel";
const RELATORIOS_ENVIAR_POR_EMAIL = URL_BASE + "/Relatorios/EnviarPorEmail";
const RELATORIOS_GERAR_VISTORIA = URL_BASE + "/Relatorios/GerarVistoria";
const RELATORIOS_GERAR_LAUDO_VISTORIA = URL_BASE + "/Relatorios/GerarLaudoVistoria"
const RELATORIOS_ENVIAR_LAUDO_VISTORIA = URL_BASE + "/Relatorios/EnviarLaudoVistoriaEmail"

const REMESSAS_LISTAR_BOLETOS_REMESSA = URL_BASE + "/Remessas/ListarBoletosRemessa";
const REMESSAS_GERAR_ARQUIVO_REMESSA = URL_BASE + "/Remessas/GerarArquivoRemessa";
const REMESSAS_RECUPERAR_NUMERO_DA_REMESSA = URL_BASE + "/Remessas/RecuperarNumeroDaRemessa";

const USUARIOS_LISTAR = URL_BASE + "/Usuarios/Listar";
const USUARIOS_RECUPERAR = URL_BASE + "/Usuarios/Recuperar";
const USUARIOS_GRAVAR = URL_BASE + "/Usuarios/Gravar";
const USUARIOS_REMOVER = URL_BASE + "/Usuarios/Remover";
const USUARIOS_REMOVER_CONTA_BANCARIA = URL_BASE + "/Usuarios/RemoverContaBancaria";
const USUARIOS_GRAVAR_CONTA_BANCARIA = URL_BASE + "/Usuarios/GravarContaBancaria";
const USUARIOS_REATIVAR = URL_BASE + "/Usuarios/Reativar";
const USUARIOS_ATIVAR = URL_BASE + "/Usuarios/Ativar";
const USUARIOS_DESATIVAR = URL_BASE + "/Usuarios/Desativar";
const USUARIOS_GRAVAR_SUPORTE = URL_BASE + "/Usuarios/GravarComoSuporte"

const VALIDAR_ACESSO = URL_BASE + "/Usuarios/ValidarAcesso";

const VENDAS_APROVAR = URL_BASE + "/Vendas/Aprovar";
const VENDAS_DESAPROVAR = URL_BASE + "/Vendas/Desaprovar";
const VENDAS_CANCELAR = URL_BASE + "/Vendas/Cancelar";
const VENDAS_GRAVAR = URL_BASE + "/Vendas/Gravar";
const VENDAS_REMOVER = URL_BASE + "/Vendas/Remover";
const VENDAS_LISTAR = URL_BASE + "/Vendas/Listar";
const VENDAS_RECUPERAR = URL_BASE + "/Vendas/Recuperar";
const VENDAS_PAGAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/PagarPagamentoComissao"; 
const VENDAS_PAGAR_COMISSAO_COMPLETA = URL_BASE + "/Vendas/PagarComissaoCompleta";
const VENDAS_GRAVAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/GravarPagamentoComissao";
const VENDAS_CANCELAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/CancelarPagamentoComissao";
const VENDAS_REMOVER_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/RemoverPagamentoComissao";

const VISTORIAS_AGENDAR = URL_BASE + "/Vistorias/Agendar";
const VISTORIAS_REMOVER = URL_BASE + "/Vistorias/Remover";
const VISTORIAS_FORCAR_CONCLUSAO = URL_BASE + "/Vistorias/ForcarConclusao";

export default {
  ADMINISTRADORAS_LISTAR,
  ADMINISTRADORAS_RECUPERAR,
  ADMINISTRADORAS_GRAVAR,
  ADMINISTRADORAS_REMOVER,
  ADMINISTRADORAS_ADICIONAR_CONDOMINIO,
  ADMINISTRADORAS_REMOVER_CONDOMINIO,

  ALUGUEIS_VERIFICAR_APROVACAO,
  ALUGUEIS_APROVAR,
  ALUGUEIS_DESAPROVAR,
  ALUGUEIS_CANCELAR_DESOCUPACAO,
  ALUGUEIS_DESOCUPAR,
  ALUGUEIS_CALCULAR_FINALIZACAO,
  ALUGUEIS_FINALIZAR_CONCLUIDO,
  ALUGUEIS_FINALIZAR,
  ALUGUEIS_FINALIZAR_COM_RESTRICOES,
  ALUGUEIS_CANCELAR_FINALIZACAO,
  ALUGUEIS_ATUALIZAR_SITUACAO_JURIDICA,
  ALUGUEIS_GRAVAR,
  ALUGUEIS_REMOVER,
  ALUGUEIS_LISTAR,
  ALUGUEIS_RECUPERAR,
  ALUGUEIS_REAJUSTAR,
  ALUGUEIS_CANCELAR_REAJUSTE,
  ALUGUEIS_RENOVAR,
  ALUGUEIS_CANCELAR_RENOVACAO,
  ALUGUEIS_ALTERAR_RENOVACAO,
  ALUGUEIS_PRORROGAR,
  ALUGUEIS_CANCELAR_PRORROGACAO,
  ALUGUEIS_ALTERAR_TAXA_ADMINISTRACAO,
  ALUGUEIS_ULTIMA_TAXA_ADM_COMPLEMENTAR,
  ALUGUEIS_RECUPERAR_MES_SERIE_PARA_FINALIZACAO,
  ALUGUEIS_RECUPERAR_RECIBOS_DESCONTO_POR_ACORDO,
  ALUGUEIS_GRAVAR_DESCONTOS,
  ALUGUEIS_GRAVAR_DESCONTOS_SALDO_NEGATIVO,
  ALUGUEIS_REMOVER_DESCONTO,
  ALUGUEIS_ALTERAR_DATA_VENCIMENTO,
  ALUGUEIS_CANCELAR_ALTERACAO_VENCIMENTO,
  ALUGUEIS_EXIBIR_RESUMO_CONTRATO,
  ALUGUEIS_ALTERAR_VALOR_CONTRATO,
  ALUGUEIS_ALTERAR_CARENCIA_CONTRATO,
  ALUGUEIS_RECUPERAR_ENVOLVIDOS,
  ALUGUEIS_GRAVAR_LANCAMENTO_FUTURO,
  ALUGUEIS_REMOVER_LANCAMENTO_FUTURO,

  ARQUIVOS_UPLOAD,
  ARQUIVOS_REMOVER,

  ARQUIVO_RETORNO_LISTAR,
  ARQUIVO_RETORNO_PROCESSAR,

  ATENDIMENTOS_LISTAR,
  ATENDIMENTOS_RECUPERAR,
  ATENDIMENTOS_CONCLUIR_PRE_CADASTRO,
  ATENDIMENTOS_CONCLUIR_CRIACAO_PERFIL,
  ATENDIMENTOS_GRAVAR_IMOVEIS,
  ATENDIMENTOS_GRAVAR_VISITA,
  ATENDIMENTOS_GRAVAR_AVALIACAO_VISITA,
  ATENDIMENTOS_LISTAR_IMOVEIS_SEMELHANTES,

  BAIRROS_LISTAR,
  BAIRROS_RECUPERAR,
  BAIRROS_GRAVAR,
  BAIRROS_REMOVER,
  BAIRROS_GRAVAR_VARIACAO,

  BOLETOS_AVULSOS_GRAVAR,
  BOLETOS_AVULSOS_REMOVER,
  BOLETOS_AVULSOS_RECUPERAR,
  BOLETOS_AVULSOS_GERAR,
  BOLETOS_AVULSOS_GERAR_BOLETOS,
  BOLETOS_AVULSOS_ENVIAR_BOLETO_POR_EMAIL,
  BOLETOS_AVULSOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL,
  BOLETOS_AVULSOS_LISTAR_BAIXAS,
  BOLETOS_AVULSOS_PAGAR,
  BOLETOS_AVULSOS_CANCELAR_PAGAMENTO,
  BOLETOS_AVULSOS_RECUPERAR_ENVOLVIDOS,
  BOLETOS_AVULSOS_PRORROGAR,
  BOLETOS_AVULSOS_CALCULAR,
  BOLETOS_AVULSOS_CANCELAR_PRORROGACAO,

  CAIXAS_RECUPERAR_CAIXA_ABERTO,
  CAIXAS_RECUPERAR_CHEQUES_NO_CAIXA,
  CAIXAS_ABRIR,
  CAIXAS_FECHAR,
  CAIXAS_GRAVAR_LANCAMENTO,
  CAIXAS_REMOVER_LANCAMENTO,
  CAIXAS_RECUPERAR_HISTORICO,
  CAIXAS_RECUPERAR_CAIXA_ANTERIOR,
  CAIXAS_RECUPERAR_HISTORICO_CHEQUE,
  CAIXAS_RECUPERAR_SALDO,

  CARACTERISTICAS_CONDOMINIO_LISTAR,
  CARACTERISTICAS_CONDOMINIO_GRAVAR,
  CARACTERISTICAS_CONDOMINIO_RECUPERAR,
  CARACTERISTICAS_CONDOMINIO_REMOVER,

  CARACTERISTICAS_IMOVEL_LISTAR,
  CARACTERISTICAS_IMOVEL_GRAVAR,
  CARACTERISTICAS_IMOVEL_RECUPERAR,
  CARACTERISTICAS_IMOVEL_REMOVER,

  CIDADES_LISTAR,
  CIDADES_RECUPERAR,
  CIDADES_GRAVAR,
  CIDADES_REMOVER,
  CIDADES_GRAVAR_VARIACAO,

  CLIENTES_LISTAR,
  CLIENTES_RECUPERAR,
  CLIENTES_GRAVAR,
  CLIENTES_REATIVAR,
  CLIENTES_REMOVER,
  CLIENTES_GRAVAR_CONTATO_REALIZADO,
  CLIENTES_ATUALIZAR_CONTATO_REALIZADO,
  CLIENTES_REMOVER_CONTATO_REALIZADO,
  CLIENTES_GRAVAR_CONTA_BANCARIA,
  CLIENTES_REMOVER_CONTA_BANCARIA,
  CLIENTES_REMOVER_CONTA_BANCARIA_COM_REPASSE,
  CLIENTES_RECUPERAR_VISITA,
  CLIENTES_GRAVAR_VISITA,
  CLIENTES_REMOVER_VISITA,
  CLIENTES_GRAVAR_REGISTRO_COBRANCA,
  CLIENTES_LISTAR_COBRANCAS,
  COBRANCAS_REMOVER,

  CONDOMINIOS_LISTAR,
  CONDOMINIOS_GRAVAR,
  CONDOMINIOS_RECUPERAR,
  CONDOMINIOS_REMOVER,

  CONTAS_LISTAR,
  CONTAS_GRAVAR,
  CONTAS_APROVAR,
  CONTAS_DESAPROVAR,
  CONTAS_DUPLICAR,
  CONTAS_CRIAR_CONTA_MENSALIDADES,
  CONTAS_RECUPERAR,
  CONTAS_CANCELAR,
  CONTAS_REMOVER,

  CONTAS_BANCARIAS_LISTAR,
  CONTAS_BANCARIAS_RECUPERAR,
  CONTAS_BANCARIAS_GRAVAR,
  CONTAS_BANCARIAS_REMOVER,

  DASHBOARD_LISTAR_IMOVEIS_MAPA,
  DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_VENDIDOS_GRAFICO,
  DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_ALUGADOS_GRAFICO,
  DASHBOARD_LISTAR_ATENDIMENTOS_GRAFICO,
  DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL,
  DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_STATUS,
  DASHBOARD_RECUPERAR_SUMARIO_STATUS_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_FOTOS,
  DASHBOARD_RECUPERAR_SUMARIO_FOTOS_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO,
  DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_ATENDIMENTO,
  DASHBOARD_IMOVEIS_CAPTADOS,
  DASHBOARD_IMOVEIS_VENDIDOS,
  DASHBOARD_RECUPERAR_ALUGUEIS_ATRASADOS,
  DASHBOARD_RECUPERAR_CONTRATOS_VENCIDOS,
  DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_VENDA,
  DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_REPASSES_DO_DIA,
  DASHBOARD_RECUPERAR_REPASSES_ATRASADOS,

  DESTAQUES_SITE_RECUPERAR_DESTAQUES_PRINCIPAIS,
  DESTAQUES_SITE_GRAVAR_DESTAQUE_PRINCIPAL,
  DESTAQUES_SITE_REMOVER_DESTAQUE_PRINCIPAL,

  EXTRATOS_DIMOB_LISTAR_PROPRIETARIOS,
  EXTRATOS_DIMOB_GERAR_EXTRATOS,
  EXTRATOS_DIMOB_GERAR_ETIQUETAS,
  EXTRATOS_DIMOB_GERAR_ARQUIVO_IMPORTACAO,

  ENCERRAR_SESSAO,

  FORMULARIOS_LISTAR,
  FORMULARIOS_RECUPERAR_FORMULARIO,
  FORMULARIOS_REMOVER,
  FORMULARIOS_GRAVAR,
  FORMULARIOS_DOWNLOAD,
  FORMULARIOS_GERAR,
  FORMULARIOS_GERAR_RECIBO_COMISSAO,
  FORMULARIOS_GERAR_RECIBO_COMISSAO_UNICO,
  FORMULARIOS_RECUPERAR,
  FORMULARIOS_RECUPERAR_PERGUNTAS,
  FORMULARIOS_CRIAR_DIRETORIO,
  FORMULARIOS_REMOVER_DIRETORIO,
  FORMULARIOS_LISTAR_DIRETORIOS,
  FORMULARIOS_SELECIONAR_DIRETORIO,

  //FORNECEDORES
  FORNECEDORES_LISTAR,
  FORNECEDORES_GRAVAR,
  FORNECEDORES_RECUPERAR,
  FORNECEDORES_REMOVER,

  //GRUPO_PLANO_CONTA
  GRUPO_PLANO_CONTA_LISTAR,
  GRUPO_PLANO_CONTA_GRAVAR,
  GRUPO_PLANO_CONTA_RECUPERAR,
  GRUPO_PLANO_CONTA_REMOVER,

  //TIPO_DESPESA
  TIPO_CONTA_GRAVAR,
  TIPO_CONTA_LISTAR,
  TIPO_CONTA_RECUPERAR,
  TIPO_CONTA_REMOVER,

  //SUB_GRUPO_CONTA
  SUB_GRUPO_LISTAR,
  SUB_GRUPO_GRAVAR,
  SUB_GRUPO_RECUPERAR,
  SUB_GRUPO_REMOVER,

  IMAGENS_UPLOAD,
  IMAGENS_REORDENAR,
  IMAGENS_EXIBIR_NA_FICHA,
  IMAGENS_REMOVER,

  IMAGENS_CARROSSEL_UPLOAD,
  IMAGENS_CARROSSEL_LISTAR,
  IMAGENS_CARROSSEL_REMOVER,

  IMOBILIARIAS_LISTAR,
  IMOBILIARIAS_RECUPERAR,
  IMOBILIARIAS_GRAVAR,
  IMOBILIARIAS_REMOVER,
  IMOBILIARIAS_RECUPERAR_PARAMETROS,
  IMOBILIARIAS_GRAVAR_PARAMETROS,
  IMOBILIARIAS_ALTERAR_LOGOMARCA,
  IMOBILIARIAS_RECUPERAR_PARAMETROS_SITE,
  IMOBILIARIAS_GRAVAR_PARAMETROS_SITE,
  IMOBILIARIAS_DESPUBLICAR_SITE,
  IMOBILIARIAS_PUBLICAR_SITE,
  IMOBILIARIAS_ALTERAR_IMAGEM_SITE,
  IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_ANIVERSARIO,
  IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_ANIVERSARIO,
  IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_PROPRIETARIO,
  IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_LOCATARIO,
  IMOBILIARIAS_PRE_CADASTRADAS_LISTAR,
  IMOBILIARIAS_PRE_CADASTRADAS_RECUPERAR,
  IMOBILIARIAS_PRE_CADASTRADAS_GRAVAR,
  IMOBILIARIAS_PRE_CADASTRADAS_REMOVER,
  IMOBILIARIAS_PRE_CADASTRADAS_GERAR_PROPOSTA,
  IMOBILIARIAS_PRE_CADASTRADAS_GERAR_CONTRATO,
  IMOBILIARIAS_GRAVAR_IMOBILIARIAS_PARCEIRAS,

  IMOVEIS_LISTAR,
  IMOVEIS_RECUPERAR,
  IMOVEIS_RECUPERAR_ALUGUEL_ATIVO,
  IMOVEIS_GRAVAR,
  IMOVEIS_DISPONIBILIZAR_VENDA,
  IMOVEIS_DISPONIBILIZAR_ALUGUEL,
  IMOVEIS_DISPONIBILIZAR,
  IMOVEIS_INDISPONIBILIZAR,
  IMOVEIS_ARQUIVAR,
  IMOVEIS_DESARQUIVAR,
  IMOVEIS_REMOVER,
  IMOVEIS_GRAVAR_LOCALIZACAO,
  IMOVEIS_RECUPERAR_ULTIMO_ID,
  IMOVEIS_RECUPERAR_VISITA,
  IMOVEIS_GRAVAR_VISITA,
  IMOVEIS_REMOVER_VISITA,
  IMOVEIS_RESERVAR_IMOVEL,
  IMOVEIS_PRORROGAR_RESERVA_IMOVEL,
  IMOVEIS_DESFAZER_RESERVA,
  IMOVEIS_ENTREGAR_CHAVE,
  IMOVEIS_RECEBER_CHAVE,
  IMOVEIS_GRAVAR_LANCAMENTO_FUTURO,
  IMOVEIS_REMOVER_LANCAMENTO_FUTURO,
  IMOVEIS_CALCULAR_PRECO_METRO_QUADRADO,

  LANCAMENTOS_RECUPERAR,
  LANCAMENTOS_GRAVAR,
  LANCAMENTOS_PAGAR,
  LANCAMENTOS_CANCELAR,
  LANCAMENTOS_REMOVER,
  LANCAMENTOS_DEVOLVER_CHEQUE,

  LOGGER_LISTAR,

  OBSERVACOES_RECUPERAR,
  OBSERVACOES_GRAVAR,
  OBSERVACOES_REMOVER,

  PARCERIAS_LISTAR_DISPONIVEIS_PARCERIA,
  PARCERIAS_GRAVAR,

  PARCERIAS_LISTAR,
  PARCERIAS_RECUPERAR,
  PARCERIAS_SOLICITAR_PARCERIA,
  PARCERIAS_ACEITAR_PARCERIA,
  PARCERIAS_REJEITAR_PARCERIA,
  PARCERIAS_RECUPERAR_IMOBILIARIAS_PARCEIRAS,
  PARCERIAS_RECUPERAR_IMOVEL,
  PARCERIAS_LISTAR_IMOVEIS_PARCEIROS,
  PARCERIAS_GRAVAR_IMOVEIS,

  PERFIS_USUARIO_LISTAR,
  PERFIS_USUARIO_RECUPERAR,
  PERFIS_USUARIO_GRAVAR,
  PERFIS_USUARIO_REMOVER,

  PLACAS_LISTAR,
  PLACAS_GRAVAR_PLACA_NO_IMOVEL,
  PLACAS_REMOVER_PLACA_DO_IMOVEL,
  PLACAS_RECUPERAR,
  PLACAS_GRAVAR,
  PLACAS_REMOVER,

  PLANO_CONTA_LISTAR,
  PLANO_CONTA_GRAVAR,
  PLANO_CONTA_RECUPERAR,
  PLANO_CONTA_REMOVER,

  PORTAIS_RECUPERAR,
  PORTAIS_GRAVAR,

  RECIBOS_LISTAR_RECIBOS_CONTRATO,
  RECIBOS_GERAR_BOLETOS_EM_ABERTO,
  RECIBOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL,
  RECIBOS_GERAR_DEMONSTRATIVO,
  RECIBOS_ENVIAR_DEMONSTRATIVO_POR_EMAIL,
  RECIBOS_GERAR_BOLETO,
  RECIBOS_ENVIAR_BOLETO_POR_EMAIL,
  RECIBOS_CALCULAR_ALUGUEL,
  RECIBOS_CALCULAR_REPASSE,
  RECIBOS_BLOQUEAR_BAIXA,
  RECIBOS_DESBLOQUEAR_BAIXA,
  RECIBOS_PRORROGAR_BOLETO,
  RECIBOS_CANCELAR_PRORROGACAO,
  RECIBOS_EFETUAR_PAGAMENTO,
  RECIBOS_CANCELAR_PAGAMENTO,
  RECIBOS_LIBERAR_REPASSE,
  RECIBOS_CANCELAR_REPASSE,
  RECIBOS_GRAVAR_ITEM,
  RECIBOS_REMOVER_ITEM,
  RECIBOS_LISTAR_BAIXAS, 
  RECIBOS_LISTAR_REPASSES,
  RECIBOS_LIBERAR_REPASSE_EM_LOTE,
  RECIBOS_GERAR_DEMONSTRATIVOS,

  RELATORIOS_GERAR,
  RELATORIOS_GERAR_DIMOB,
  RELATORIOS_GERAR_RELATORIO_CLIENTES_ALUGUEL,
  RELATORIOS_GERAR_RELATORIO_CLIENTES_VENDA,
  RELATORIOS_GERAR_RELATORIO_CONTRATOS_ALUGUEL,
  RELATORIOS_GERAR_RELATORIO_IMOVEIS_ALUGUEL,
  RELATORIOS_ENVIAR_POR_EMAIL,
  RELATORIOS_GERAR_VISTORIA,
  RELATORIOS_GERAR_LAUDO_VISTORIA,
  RELATORIOS_ENVIAR_LAUDO_VISTORIA,

  REMESSAS_LISTAR_BOLETOS_REMESSA,
  REMESSAS_GERAR_ARQUIVO_REMESSA,
  REMESSAS_RECUPERAR_NUMERO_DA_REMESSA,

  USUARIOS_LISTAR,
  USUARIOS_RECUPERAR,
  USUARIOS_GRAVAR,
  USUARIOS_REMOVER,
  USUARIOS_REMOVER_CONTA_BANCARIA,
  USUARIOS_GRAVAR_CONTA_BANCARIA,
  USUARIOS_REATIVAR,
  USUARIOS_ATIVAR,
  USUARIOS_DESATIVAR,
  USUARIOS_GRAVAR_SUPORTE,

  VALIDAR_ACESSO,

  VENDAS_APROVAR,
  VENDAS_DESAPROVAR,
  VENDAS_CANCELAR,
  VENDAS_GRAVAR,
  VENDAS_REMOVER,
  VENDAS_LISTAR,
  VENDAS_RECUPERAR,
  VENDAS_PAGAR_PAGAMENTO_COMISSAO,
  VENDAS_PAGAR_COMISSAO_COMPLETA,
  VENDAS_GRAVAR_PAGAMENTO_COMISSAO,
  VENDAS_CANCELAR_PAGAMENTO_COMISSAO,
  VENDAS_REMOVER_PAGAMENTO_COMISSAO,

  VISTORIAS_AGENDAR,
  VISTORIAS_REMOVER,
  VISTORIAS_FORCAR_CONCLUSAO,
}